/**
 * Every Gateway path the Users module calls.
 *
 * Collected here so a route change is one edit, and so a reader can see the
 * module's entire surface against the platform without grepping for string
 * literals in JSX.
 */
export const userEndpoints = {
  list: '/v1/users',
  create: '/v1/users',
  detail: (userId: string) => `/v1/users/${encodeURIComponent(userId)}`,
  update: (userId: string) => `/v1/users/${encodeURIComponent(userId)}`,
  roles: (userId: string) => `/v1/users/${encodeURIComponent(userId)}/roles`,
  properties: (userId: string) => `/v1/users/${encodeURIComponent(userId)}/properties`,
  delete: (userId: string) => `/v1/users/${encodeURIComponent(userId)}`,
} as const;
